import { render } from "./chooseSpace.vue?vue&type=template&id=24b26e47&scoped=true"
import script from "./chooseSpace.vue?vue&type=script&lang=js"
export * from "./chooseSpace.vue?vue&type=script&lang=js"

import "./chooseSpace.vue?vue&type=style&index=0&id=24b26e47&scoped=true&lang=scss"
import "./chooseSpace.vue?vue&type=style&index=1&id=24b26e47&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b26e47"]])

export default __exports__